<template>
  <div>
    <div style="margin-bottom: 16px">
      <el-button class="mwow-button-filled success" @click="handleAddSet"
        >添加套餐</el-button
      >
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="套餐搜索:" prop="name">
              <el-input
                v-model="searchInfo.name"
                placeholder="请输入套餐名称"
                maxlength="100"
                @change="handleSearchSet"
                clearable
                prefix-icon="el-icon-search"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="线下购买:" prop="status">
              <el-radio-group
                v-model="searchInfo.status"
                @change="handleSearchSet"
              >
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button :label="1">开启</el-radio-button>
                <el-radio-button :label="2">关闭</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      :data="tableData"
      stripe
      v-horizontal-scroll
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="排序" prop="sort" width="120">
        <template slot-scope="scope">
          <sort-editor
            type="set"
            :id="scope.row.combo_product_id"
            :ori="scope.row.sort"
          ></sort-editor>
        </template>
      </el-table-column>
      <el-table-column label="套餐名称" prop="name"></el-table-column>
      <el-table-column label="套餐价格" prop="price"></el-table-column>
      <el-table-column label="线下购买" prop="status">
        <template slot-scope="scope">
          <el-switch
            @change="() => confirmSetStatus(scope.row)"
            v-model="scope.row.status"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <el-button class="mwow-button success" @click="toDetail(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { setList, changeSetStatus, setDetail } from "@/api/course";
import sortEditor from "./sortEditor.vue";
import { PageModule } from "@/store/module/page";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    sortEditor,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        name: "",
        status: -1,
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    const cache = PageModule.pageInfo.storeCourse;
    if (cache.pages) {
      this.page = cache.pages;
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        name: "",
        status: -1,
      };
      this.handleSearchSet();
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (this.searchInfo.status >= 0) {
        option.status = this.searchInfo.status;
      }
      setList(option).then((res) => {
        if (res.error_code === 0) {
          const arr = res.data.list || [];
          arr.map((item) => {
            item.status = item.status === 1;
          });
          this.tableData = arr;
          this.total = res.data.total;
          this.page = params.page;
        }
      });
    },
    handleAddSet() {
      this.$router.push({
        name: "storeSetDetail",
        query: {
          id: "0",
        },
      });
    },
    handleSearchSet() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    toDetail(row) {
      this.$router.push({
        name: "storeSetDetail",
        query: {
          id: row.combo_product_id,
        },
      });
    },
    confirmSetStatus(row) {
      if (row.status) {
        setDetail({ combo_product_id: row.combo_product_id }).then((result) => {
          if (result.error_code === 0) {
            let str = "";
            result.data.item.map((i) => {
              if (i.item_type === 1) {
                str = str + i.product_name + "、";
              }
            });
            str = str.replace(/.$/, "");
            if (str) {
              const title = `开启购买 - ${row.name}`;
              const content = `开启套餐后，套餐下包含的已关闭课程都将开启。${str}`;
              this.$confirm(content, title, {
                confirmButtonText: "确定",
                confirmButtonClass: "mwow-button-filled success mini",
                cancelButtonText: "取消",
                cancelButtonClass: "mwow-button-filled mini",
                type: "warning",
              })
                .then(() => {
                  this.handleSetStatus(row.combo_product_id, 1);
                })
                .catch(() => {
                  this.getList({
                    page: this.page,
                    page_size: this.pageSize,
                  });
                });
            } else {
              this.handleSetStatus(row.combo_product_id, 1);
            }
          }
        });
      } else {
        this.handleSetStatus(row.combo_product_id, 2);
      }
    },
    handleSetStatus(cid, status) {
      changeSetStatus({
        combo_product_id: cid,
        status: status,
      })
        .then((res) => {
          if (res.error_code == 0) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: "修改失败!" + res.message,
            });
          }
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        })
        .catch(() => {
          this.getList({
            page: this.page,
            page_size: this.pageSize,
          });
        });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "storeCourse",
        key: "pages",
        value: e,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
